/* Olyra Shoulder Wrap : galerie, lots, ajout au panier, barre collante, quiz. Se ré-initialise sur shopify:section:load. */
(function () {
  function initGallery(root) {
    root.querySelectorAll('[data-sw-gal]').forEach(function (g) {
      var imgs = g.querySelectorAll('.sw-gal__main img'), th = g.querySelectorAll('.sw-gal__thumbs button');
      th.forEach(function (b, i) { b.onclick = function () { imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); }); th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-pressed', k === i); }); }; });
    });
  }
  function initBuy(root) {
    root.querySelectorAll('[data-sw-buy]').forEach(function (box) {
      var radios = box.querySelectorAll('input[name^="sw-pack"]'), btn = box.querySelector('[data-sw-add]'), msg = box.querySelector('[data-sw-msg]');
      if (!btn) return;
      var now = document.querySelectorAll('[data-sw-now]'), was = document.querySelectorAll('[data-sw-was]'), save = document.querySelectorAll('[data-sw-save]'), lbl = box.querySelector('[data-sw-add-price]');
      function sync() {
        var r = box.querySelector('input[name^="sw-pack"]:checked'); if (!r) return;
        now.forEach(function (e) { e.textContent = r.dataset.now; }); document.querySelectorAll('[data-sw-lotname]').forEach(function (e) { e.textContent = r.dataset.name; }); was.forEach(function (e) { e.textContent = r.dataset.was; }); save.forEach(function (e) { e.textContent = r.dataset.save; });
        if (lbl) lbl.textContent = r.dataset.now;
        btn.disabled = !r.dataset.variant; msg.textContent = r.dataset.variant ? '' : btn.dataset.missing;
        btn.dataset.variant = r.dataset.variant || '';
      }
      radios.forEach(function (r) { r.addEventListener('change', sync); }); sync();
      btn.onclick = function () {
        if (!btn.dataset.variant) return;
        btn.disabled = true; msg.textContent = '';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }) })
          .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
          .then(function () {
            if (window.OlySwCart) { btn.disabled = false; return window.OlySwCart.open(); }
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          })
          .catch(function () { btn.disabled = false; msg.textContent = btn.dataset.error; });
      };
    });
  }
  /* Fiche produit : vrai formulaire /cart/add (lots Moon Bundle). Le FormData part tel quel (Moon y règle quantité et propriétés),
     en AJAX, puis le tiroir s'ouvre. Sans tiroir, le formulaire est envoyé normalement. */
  function initForm(root) {
    root.querySelectorAll('[data-sw-buy] form[action*="/cart/add"]').forEach(function (f) {
      if (f.dataset.swReady) return; f.dataset.swReady = '1';
      f.addEventListener('submit', function (e) {
        if (!window.OlySwCart || !window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = f.querySelector('[data-sw-submit]'), msg = f.querySelector('[data-sw-msg]');
        if (btn) btn.disabled = true; if (msg) msg.textContent = '';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
          .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
          .then(function () { if (btn) btn.disabled = false; return window.OlySwCart.open(); })
          .catch(function (er) { if (btn) btn.disabled = false; if (msg) msg.textContent = (er && er.description) || (btn && btn.dataset.error) || ''; });
      });
    });
  }
  /* Fiche produit : le bloc prix du héros, le bouton et la barre collante suivent la carte active de Moon Bundle.
     Lot présélectionné à l'arrivée = réglage « Lot présélectionné » de la section (data-sw-def). */
  function initMoon(root) {
    root.querySelectorAll('.sw-moon[data-sw-def]').forEach(function (box) {
      if (box.dataset.swSync) return; box.dataset.swSync = '1';
      var names = (box.dataset.swNames || '').split('|'), def = Number(box.dataset.swDef) || 2, picked = false, raf = 0;
      function cents(t) { t = (t || '').trim(); var d = t.replace(/[^\d]/g, ''); if (!d) return null; return /\d[.,]\d{2}(?!\d)/.test(t) ? Number(d) : Number(d) * 100; }
      function group(x, sep) { return sep ? x.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : x; }
      function fmt(c) {
        var s = box.dataset.swMoney || '', n = Math.abs(Math.round(c));
        var m = s.match(/^([\s\S]*?)12(\D?)345(\D)67([\s\S]*)$/);
        if (m) return m[1] + group(String(Math.floor(n / 100)), m[2]) + m[3] + ('0' + (n % 100)).slice(-2) + m[4];
        m = s.match(/^([\s\S]*?)12(\D?)346([\s\S]*)$/);
        if (m) return m[1] + group(String(Math.round(n / 100)), m[2]) + m[3];
        return (n / 100).toFixed(2);
      }
      function set(sel, v) { document.querySelectorAll(sel).forEach(function (e) { if (e.textContent !== v) e.textContent = v; }); }
      function sync() {
        var opts = box.querySelectorAll('.moonbundle-option'); if (!opts.length) return;
        var a = box.querySelector('.moonbundle-option-active'), i = Array.prototype.indexOf.call(opts, a);
        if (!picked) { picked = true; if (opts[def - 1] && i !== def - 1) { opts[def - 1].click(); return; } }
        if (i < 0) return;
        var pe = a.querySelector('.moonbundle-option-single-price'), oe = a.querySelector('.moonbundle-option-old-price');
        var now = pe ? pe.textContent.trim() : '', was = oe ? oe.textContent.trim() : '';
        if (!now) return;
        var pc = cents(now), wc = cents(was), save = (pc !== null && wc !== null && wc > pc) ? fmt(wc - pc) : '';
        set('[data-sw-now]', now); set('[data-sw-add-price]', now); set('[data-sw-was]', was || now); set('[data-sw-save]', save);
        document.querySelectorAll('.sw-price__save').forEach(function (e) { e.hidden = !save; });
        if (names[i]) set('[data-sw-lotname]', names[i]);
      }
      function later() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }
      if ('MutationObserver' in window) new MutationObserver(later).observe(box, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      box.addEventListener('click', function () { setTimeout(sync, 0); });
      sync();
    });
  }
  function initSticky() {
    var s = document.querySelector('[data-sw-sticky]'), t = document.querySelector('[data-sw-buy]');
    if (!s || !t || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { var e = en[0]; s.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    io.observe(t);
  }
  function initQuiz(root) {
    root.querySelectorAll('[data-sw-quiz]').forEach(function (q) {
      q.querySelectorAll('[data-sw-opt]').forEach(function (b) {
        b.onclick = function () {
          q.querySelectorAll('[data-sw-opt]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
          q.querySelectorAll('[data-sw-res]').forEach(function (r) { r.hidden = r.dataset.swRes !== b.dataset.swOpt; });
        };
      });
    });
  }
  function all(root) { initGallery(root); initBuy(root); initForm(root); initMoon(root); initQuiz(root); }
  document.addEventListener('DOMContentLoaded', function () { all(document); initSticky(); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); initSticky(); });
})();
